import { useContent } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Tooltip } from 'src/core/ui';
import { WarningOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './EventStatus.css';

export const EventDeletedIcon = () => {
  const deletedText = useContent(ContentId.Deleted);

  return (
    <Tooltip
      align="center"
      triggerContent={
        <div>
          <WarningOutlineIcon
            fill={vars.color.textError}
            className={styles.eventDisplayIcon}
          />
        </div>
      }
    >
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'unset',
          textOverflow: 'unset',
          minWidth: 'fit-content',
        }}
      >
        {deletedText}
      </div>
    </Tooltip>
  );
};
